import React from 'react';
import dayjs from 'dayjs';
import './dateText.scss';

interface IDateTextProps {
  date?: string;
  type?: 'div' | 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4';
}

const DateText = ({ date, type = 'div' }: IDateTextProps) => {
  const Component = type;
  const formattedDate = dayjs(date).format('MMMM D, YYYY');

  return <Component className="update-day">{formattedDate}</Component>;
};

export default DateText;
